import { types } from '../constants';

export const fetchAllPersonnelsDispatch = (branchId) => ({
  type: types.FETCH_ALL_PERSONNELS,
  branchId
});

export const openCreatePersonnelDialogDispatch = (open, isShort) => ({
  type: types.OPEN_CREATE_PERSONNEL_DIALOG,
  open,
  isShort
});

export const searchTermChangeForAllPersonnels = (searchTerm) => ({
  type: types.CHANGE_SEARCH_TERM_ALL_PERSONNELS,
  searchTerm
});

export const handlePersonnelInputChangeDispatch = (value, inputFieldName) => ({
  type: types.INPUT_CHANGE_CREATE_PERSONNEL_FORM,
  value,
  inputFieldName
});

export const submitPersonnelDispatch = (personnel, mode) => ({
  type: types.SUBMIT_PERSONNEL,
  personnel,
  mode
});

export const changeValidationStateDispatch = (validationState) => ({
  type: types.CHANGE_NEW_PERSONNEL_VALIDATION_STATE,
  validationState
});

export const openEditPersonnelDialogDispatch = (open) => ({
  type: types.OPEN_EDIT_PERSONNEL_DIALOG,
  open
});

export const personnelEditClickDispatch = (personnel) => ({
  type: types.EDIT_PERSONNEL,
  personnel
});

export const openCoursesForPersonnelDialog = (open, personnel) => ({
  type: types.OPEN_COURSES_FOR_PERSONNEL_DIALOG,
  open,
  personnel
});

export const clearAllCoursesForPersonnel = () => ({
  type: types.CLEAR_ALL_COURSES_FOR_PERSONNEL
});

export const getCoursesForPersonnelDispatch = (personnelId) => ({
  type: types.FETCH_COURSES_FOR_PERSONNEL,
  personnelId
});

export const openDeletePersonnelDialogDispatch = (open) => ({
  type: types.OPEN_DELETE_PERSONNEL_DIALOG,
  open
});

export const openAddCourseRecordDialogDispatch = (
  open,
  personnelId,
  source
) => ({
  type: types.OPEN_ADD_COURSE_RECORD_DIALOG,
  open,
  personnelId,
  source
});
